import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink } from "lucide-react";

export default function Publications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/publications").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="publications-page">
      <section className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20">
        <p className="text-xs tracking-[0.3em] uppercase text-[#C24D2C]">Publications</p>
        <h1 className="mt-4 font-serif-display text-5xl lg:text-6xl text-[#1A2456] font-bold max-w-4xl">
          Peer-reviewed writing.
        </h1>

        {loading ? (
          <p className="mt-14 text-[#8A817C]">Loading…</p>
        ) : items.length === 0 ? (
          <p className="mt-14 text-[#8A817C] italic">No publications listed yet.</p>
        ) : (
          <div className="mt-14 space-y-8">
            {items.map((p, i) => (
              <article
                key={p.id}
                data-testid={`publication-${p.id}`}
                className="grid grid-cols-[auto_1fr] gap-6 border-b border-[#D8CFC4] pb-8"
              >
                <span className="font-serif-display text-5xl text-[#E35D29]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2 className="font-serif-display text-2xl text-[#1A2456]">{p.title}</h2>
                  <p className="mt-2 text-sm text-[#2D2825]">{p.authors}</p>
                  <p className="mt-2 text-xs tracking-[0.2em] uppercase text-[#8A817C]">
                    {p.journal}
                    {p.year ? ` · ${p.year}` : ""}
                  </p>
                  {p.abstract && (
                    <p className="mt-4 text-[#5C544F] leading-relaxed">{p.abstract}</p>
                  )}
                  {p.link && (
                    <a
                      data-testid={`publication-link-${p.id}`}
                      href={p.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 inline-flex items-center gap-2 text-sm text-[#E35D29] link-underline"
                    >
                      Read paper <ExternalLink size={14} />
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
